// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/modelsDetail.scss'

// Responsive Tabs
async function getRTabs () {
  import(/* webpackChunkName: "responsiveTabs" */ './js/components/responsiveTabs.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// MasterSlider
async function getMasterSlider () {
  import(/* webpackChunkName: "masterSlider", webpackPrefetch: true */ './js/components/masterSlider.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Gallery
async function getPhotoswipe () {
  import(/* webpackChunkName: "photoswipe", webpackPrefetch: true */ './js/components/photoswipe.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agencies Search Form
async function getAsForm ($f) {
  $f.load()
  import(/* webpackChunkName: "agenciesSearchForm" */ './js/components/agenciesSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agency autocomplete
async function getAgenciesAutocomplete ($f) {
  import(/* webpackChunkName: "agenciesAutocomplete" */ './js/components/agenciesAutocomplete.js').then(module => {
    module.agenciesAutocomplete.init($f)
  })
}

// ModelLike
async function getModelLike ($add) {
  import(/* webpackChunkName: "modelLike" */ './js/components/modelLike.js').then(module => {
    module.modelLike.init()
    $add.trigger('click')
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // responsive tabs
  $('#desc-tabs').waypoint(function () {
    getRTabs()
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion model items
  const $modelitem = $('.model-item')
  if ($modelitem.length) {
    $modelitem.waypoint(function () {
      import(/* webpackChunkName: "modelItem" */ './scss/components/modelItem.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion master slider
  const $c1 = $('#masterslider')
  if ($c1.length) {
    $c1.waypoint(function () {
      getMasterSlider()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des galeries
  const $c2 = $('.gallery')
  if ($c2.length) {
    $c2.waypoint(function () {
      getPhotoswipe()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $c3 = $('form[name="cForm"]')
  if ($c3.length) {
    $c3.waypoint(function () {
      getCForm($c3)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion de la recherche d'agences la plus proche
  const $c4 = $('form[name="asForm"]')
  if ($c4.length) {
    $c4.waypoint(function () {
      getAsForm($c4)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="asForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getAgenciesAutocomplete($(this).parents('form'))
  })

  // boutons like sur le modèle détaillé
  $('#like').on('click', function () {
    getModelLike($(this))
  })
  // boutons d'action sur le modèle détaillé
  $('#track-f').on('click', function () {
    /* global ga */
    if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Financement modele', 'Clic') }
    /* global gtag */
    if (typeof (googletag) !== 'undefined') { gtag('event', 'financing_model') }
  })
  $('#track-c').on('click', () => { // event sur bouton contact : track event google analytics
    if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Contacter modele', 'Clic') }
    if (typeof (googletag) !== 'undefined') { gtag('event', 'contact_model') }
  })
  $('#track-g').on('click', () => { // event sur bouton modèle
    if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Recherche terrain', 'Clic') }
    if (typeof (googletag) !== 'undefined') { gtag('event', 'ground_search') }
  })

  // ancre
  $.each($('.scroll'), function (i, elem) {
    $(elem).off().on('click', function (e) {
      const t = ($(e.target).is('a')) ? this.hash : $(this).attr('target')
      e.preventDefault()
      if ($(t).length > 0) {
        const h = $('#header').height()
        const p = $('#sub-nav').height()
        $('html').animate({ scrollTop: $(t).offset().top - h - p - 10 }, { duration: 300, easing: 'linear' }, function () {
          $('html').animate({ scrollTop: $(t).offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
        })
      }
    })
  })
})
